module.exports = "https://static-www.niulinkcloud.com/_next/static/media/biz-wexin.ec056b996dd5c036c63364027fc3bfbf.png";